import util from '../util'

let controller = 'CadastroFavorecidoLoteArquivoLinha'
export default Object.assign({}, util.GetCrud(controller, null), {
    Aprovar: function (dto) {
        return util.Axios.Post(controller + '/Aprovar', dto)
    },
    Rejeitar: function (dto) {
        return util.Axios.Post(controller + '/Rejeitar', dto)
    },
})
